import { render, staticRenderFns } from "./CreateProgram.vue?vue&type=template&id=684267f6"
import script from "./CreateProgram.vue?vue&type=script&lang=js"
export * from "./CreateProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports